import { useMutation } from "@apollo/client/react";
import { UPDATE_INVOICE_DETAILS } from "../../mutations/invoices/updateInvoiceDetails";
import GET_INVOICE_LATEST_VALIDATION_RESULT from "../../queries/invoices/getInvoiceLatestValidationResult";
import GET_INVOICE_DUPLICATES from "../../queries/invoices/getInvoiceDuplicates";
import GET_CLIENT_INVOICES from "../../queries/invoices/getClientInvoices";

export const useUpdateInvoiceDetails = ({
  onCompleted,
  onError,
  noRefetch = false,
}: {
  onCompleted: (result?: any) => void;
  onError: (e?: any) => void;
  noRefetch?: boolean;
}) => {
  const [updateInvoiceDetails, { data, loading, error }] = useMutation(
    UPDATE_INVOICE_DETAILS,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: noRefetch
        ? []
        : [
            GET_INVOICE_LATEST_VALIDATION_RESULT,
            GET_INVOICE_DUPLICATES,
            GET_CLIENT_INVOICES,
          ],
      awaitRefetchQueries: true,
    },
  );

  return { updateInvoiceDetails, data, loading, error };
};
